import { convertToNumber } from '../../Basics/util';
import { SelectedUnits, UserInputUnits } from '../UnitSelection';

export function getNumberOfUnits(units: SelectedUnits | UserInputUnits): number {
  return Object.values(units).reduce((total, unit: string | number) => total + convertToNumber(unit), 0);
}
